import { combineReducers } from "redux";
import AuthReducer from "./reducers/AuthReducer";
import CurrencyReducer from "./reducers/CurrenciesReducer";
import DashboardReducers from "./reducers/dashboardReducers";

import LanguageReducers from "./reducers/languageReducers";
import MessageBarReducer from "./reducers/MessageBarReducer";
import { SIGN_OUT } from "./actions/actionTypes";
import ErrorReducer from "./reducers/ErrorReducer";
import TransferReducer from "./reducers/TransferReducer";
import RecurringPaymentReducers from "./reducers/recurringPaymentReducers";

const rootReducers = (state, action) => {
  const appReducer = combineReducers({
    MessageBar: MessageBarReducer,
    Auth: AuthReducer,
    language: LanguageReducers,
    currencies: CurrencyReducer,
    dashboard: DashboardReducers,
    error: ErrorReducer,
    transfer: TransferReducer,
    recurring: RecurringPaymentReducers
  });
  if (action.type === SIGN_OUT) state = undefined;

  return appReducer(state, action);
};

export default rootReducers;
